<template>
    <div>
            <panel-admin> </panel-admin>
    </div>
</template>
<script>
    import PanelAdmin from "../components/PanelAdmin";
    export default {
        name: "Dashboard",
        components: {PanelAdmin},
        mounted() {
        }
    }
</script>

<style scoped>

</style>